/* eslint-disable no-nested-ternary */
/* eslint-disable radix */
/* eslint-disable indent */
/* eslint-disable no-undef */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useState, useEffect, createContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled, Button, Grid, Backdrop, Chip, CircularProgress } from '@mui/material';
import { isEmpty } from 'lodash';
import DoneIcon from '@mui/icons-material/Done';
import { defaultUnitValues, defaultModalOptions } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import { Application, FeedWater, PreTreatment, systemUnitsIconColor, ROMOpen } from '../../shared/assets/images';
import { dbTransaction, getFlowSheet } from '../../shared/api/url-helper';
import { convertUnitValues_flow } from '../../shared/conversion-helper/unitConversion';
import { removeLocalStorageValue, isObjectEmpty } from '../../shared/helper';
import { decrypt_data } from '../../shared/utils';
import SystemUnits from '../system-units';
import { clearLogs } from '../../logger';
import './wizard.scss';
import { getDbTransactionData, setDbTransactionData } from '../userData';

const MuiChipCustom = styled(Chip)(() => ({
  borderRadius: '6px',
  margin: 1,
}));

export const ExecuteContext = createContext();

function FlowSheetWizardv1() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const translateObject = t;
  const [selected, setSelected] = React.useState({});
  const [fetchLoading, setFetchLoading] = useState(false);
  const [isShowErrorMessage, setIsShowErrorMessage] = useState(false);
  const [ButtonLoads, setButtonLoads] = useState(true);
  const [flowsheet_wizard_dict, setflowsheet_wizard_dict] = useState({});
  // const [, setflowsheet_wizard_dict_App_Table] = useState({});
  const [loadedFile, setLoadedFile] = useState([]);
  const [flowRange, setFlowRange] = useState({ min: 1.1, max: 1000 });
  const SessionExpTime = sessionStorage.getItem('expTime');
  let currTime = new Date().getTime().toString();
  currTime = currTime.substring(0, 10); // 1653312386

  if (parseInt(currTime) >= parseInt(SessionExpTime)) {
    removeItemFromLocalStorage();
    if (localStorage.getItem('db_version')) {
      localStorage.removeItem('db_version');
    }
    clearLogs();
    window.location.href = '/sign-in';
  };
  // Get the default unit set from localStorage
  const defaultUnitSetDict = JSON.parse(localStorage.getItem('default_unit_set_dict'));

  // Initialize the 'units' state with the default unit set from localStorage or a default value ----> Kranthi
  const [units, setUnits] = useState(
    // Check if the default unit set exists in localStorage
    defaultUnitSetDict
      ? {
        // If it exists, create an object with the following properties
        type: defaultUnitSetDict.type, // Type of unit set
        temp: defaultUnitSetDict.Temperature, // Temperature unit
        pressure: defaultUnitSetDict.Pressure, // Pressure unit
        flow: defaultUnitSetDict['Volume Flow'], // Volume flow unit
        flux: defaultUnitSetDict.Flux, // Flux unit
        power: defaultUnitSetDict.Power, // Power unit
        volume: defaultUnitSetDict['Liquid Volume'], // Liquid volume unit
      }
      : (!isEmpty(JSON.parse(localStorage.getItem('system-units'))) ? JSON.parse(localStorage.getItem('system-units')) : defaultUnitValues));
  // notification modal
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  // system units
  const [visibleUnits, setVisibleUnits] = useState(false);

  const [FlowValue, setFlowValue] = React.useState('');
  const [PreFlowValue, setPreFlowValue] = React.useState('');
  const [checkedFlow, setCheckedFlow] = useState('Feed Flow'); // Add this state
  const executeEDIInfoData = useMemo(() => ({ data: {}, reportData: {} }), []);
  const handleCloseOption = () => {
    setVisibleUnits(false);
  };
  const openModelPopUp = (message, title, type) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title,
      message,
      yesOrNo: false,
      onNo: () => setModalOption(defaultModalOptions),
      type
    });
  };
  // Assuming that the dynamic FlowValues for chipData can be retrieved from an API response
  // or a configuration file, we can refactor the code as follows:
  const handleOnBlur = (event) => {
    if ((event.target.value > flowRange.min && (event.target.value) < flowRange.max) || (event.target.value) === '') {
    } else {
      event.preventDefault();
      setButtonLoads(true);
      openModelPopUp(`Feed Flow value must be between ${Math.round(flowRange.min * 10) / 10} ${units.flow} and ${flowRange.max} ${units.flow}`, 'Error', 'error');
    };
  };
  const handleOnChange = (event) => {
    setFlowValue((event.target.value)); // Set the flow value based on the value of the event target
    if ((event.target.value > flowRange.min && (event.target.value) < flowRange.max) || (event.target.value) === '') {
      if ((event.target.value) === '') {
        setSelected((prevFilterValues) => ({
          ...prevFilterValues,
          'Feed Flow': event.target.value, // Update the selected 'Feed Flow' value with the new flow value
        }));
        setButtonLoads(true);
      } else {
        setSelected((prevFilterValues) => ({
          ...prevFilterValues,
          'Feed Flow': event.target.value, // Update the selected 'Feed Flow' value with the new flow value
        }));
        setButtonLoads(false);
      };
    } else {
      setButtonLoads(true);
    };
  };
  const wizardData = (decData) => {
    if (Object.keys(decData).length !== 0) {
      if (Object.keys(decData?.flowsheet_wizard_dict).length !== 0) {
        setflowsheet_wizard_dict(decData?.flowsheet_wizard_dict || {});
        // setflowsheet_wizard_dict_App_Table(decData?.flowsheet_wizard_dict?.app_dict || {});
        // checking is 'AppWiz' localStorage present then set the all selection to prev. value & press 'See result' btn
        if (localStorage.getItem('appWiz') && !isObjectEmpty(selected)) {
          const appWizLocal = JSON.parse(localStorage.getItem('appWiz'));
          setSelected({
            ...selected,
            'Application': appWizLocal.application,
            'Feed Water': appWizLocal.feedWater,
            'Pre Treatment': appWizLocal.pTreatment,
            'Feed Flow': appWizLocal.feedFlow
          }
          );
          setFlowValue(appWizLocal.feedFlow);
          setButtonLoads(false);
          setTimeout(() => {
            document.getElementById('appwizard_seeResult').click();
          }, 5);
        }
      } else {
        openModelPopUp('Failed to fetch DB transaction record', 'Error', 'error');
      }
    }
  };
  useEffect(async () => {
    setFetchLoading(true);
    const decData = getDbTransactionData();
    if (decData) {
      removeLocalStorageValue();
      setFetchLoading(false);
      wizardData(decData);
    } else {
      Promise.all([dbTransaction()]).then((res) => {
        removeLocalStorageValue();
        setFetchLoading(false);
        const decData = decrypt_data(res[0].data);
        res[0].data = decData;
        setDbTransactionData(decData);
        wizardData(decData);
      }).catch(() => {
        setFetchLoading(false);
        removeLocalStorageValue();
        openModelPopUp('Failed to fetch DB transaction record', 'Error', 'error');
      });
    }
  }, []);
  React.useEffect(() => {
    const firstKey = Object.keys(flowsheet_wizard_dict)[0] || ''; // Get the first key from flowsheet_wizard_dict, or set it as an empty string if no keys exist
    const secondKey = Object.keys(flowsheet_wizard_dict[firstKey] || {})[0] || ''; // Get the first key of the inner object based on the first key, or set it as an empty string if no keys exist
    const thirdKey = flowsheet_wizard_dict[firstKey]?.[secondKey][0] || ''; // Get the first key of the innermost object based on the first and second keys, or set it as an empty string if no keys exist
    setSelected({
      'Application': firstKey, // Set the 'Application' property of the selected object to the first key
      'Feed Water': secondKey, // Set the 'Feed Water' property of the selected object to the second key
      'Pre Treatment': thirdKey, // Set the 'Pre Treatment' property of the selected object to the third key
      'Feed Flow': 0, // Set the 'Feed Flow' property of the selected object to 0
      'unit_set_dict': units,
    });
  }, [flowsheet_wizard_dict]);
  const handleSubList = (Label) => {
    let labels; // Variable to store the resulting labels
    if (Label === 'Application') {
      labels = Object.keys(flowsheet_wizard_dict) || []; // Get the keys from flowsheet_wizard_dict
    } else if (Label === 'Feed Water') {
      labels = selected.Application ? Object.keys(flowsheet_wizard_dict[selected.Application] || {}) : []; // Get the keys based on the selected application
    } else {
      labels = (selected.Application && selected['Feed Water']) ? flowsheet_wizard_dict[selected.Application][selected['Feed Water']] : []; // Get the keys based on the selected application and feed water
    }
    return labels; // Return the resulting labels
  };

  const handleOnClick = (event, categorys, value) => {
    if (categorys === 'Application') { // If the category is 'Application'
      setSelected((prevFilterValues) => ({
        ...prevFilterValues,
        [categorys]: value, // Update the selected 'Application' value
        'Feed Water': Object.keys(flowsheet_wizard_dict[value])[0], // Set the first 'Feed Water' value based on the selected 'Application'
        'Pre Treatment': flowsheet_wizard_dict[value][Object.keys(flowsheet_wizard_dict[value])[0]][0], // Set the first 'Pre Treatment' value based on the selected 'Application' and 'Feed Water'
        'Feed Flow': FlowValue // Set the 'Feed Flow' value to the current flow value
      }));
    };

    if (categorys === 'Feed Water') { // If the category is 'Feed Water'
      setSelected((prevFilterValues) => ({
        ...prevFilterValues,
        [categorys]: value, // Update the selected 'Feed Water' value
        'Pre Treatment': flowsheet_wizard_dict[prevFilterValues.Application][value][0], // Set the first 'Pre Treatment' value based on the selected 'Application' and current 'Feed Water'
        'Feed Flow': FlowValue // Set the 'Feed Flow' value to the current flow value
      }));
    };

    if (categorys === 'Pre Treatment') { // If the category is 'Pre Treatment'
      setSelected((prevFilterValues) => ({
        ...prevFilterValues,
        [categorys]: value, // Update the selected 'Pre Treatment' value
        'Feed Flow': FlowValue // Set the 'Feed Flow' value to the current flow value
      }));
    };
  };
  useEffect(() => {
    if (!isEmpty(JSON.parse(localStorage.getItem('system-units')))) {
      setUnits(JSON.parse(localStorage.getItem('system-units')));
    }
    setPreFlowValue(units.flow);
  }, [visibleUnits]);

  useEffect(() => {
    setFlowRange({
      min: parseFloat(convertUnitValues_flow(1, 'm3/hr', units.flow).toFixed(1)),
      max: parseFloat(convertUnitValues_flow(1000, 'm3/hr', units.flow).toFixed(1))
    });
    if (FlowValue) {
      setFlowValue(parseFloat(convertUnitValues_flow(FlowValue, PreFlowValue, units.flow).toFixed(1)));
    }
  }, [units]);
  // Function to handle result click
  const handleResultClick = () => {
    // Set loading state to true
    setFetchLoading(true);
    const convert_flow_value = parseFloat(convertUnitValues_flow(FlowValue, units.flow, 'm3/s'));
    const unit_set_dict = {
      'Volume Flow': units.flow,
      'Pressure': units.pressure,
      'Temperature': units.temp,
      'Liquid Volume': units.volume,
      'Flux': units.flux,
      'Power': units.power,
      'type': units.type
    };
    // Define the input dictionary for the recommender
    const recommender_input_dict = {
      'app_type': selected.Application, // Application type
      'water_type': selected['Feed Water'], // Type of feed water
      'pretreatment': selected['Pre Treatment'], // Pre-treatment type
      'feed_capacity': checkedFlow === 'Feed Flow' ? convert_flow_value : 0, // Feed capacity
      'product_capacity': checkedFlow === 'Product Flow' ? convert_flow_value : 0, // Feed capacity
      'unit_set_dict': unit_set_dict, // Unit set dictionary
    };
    // Promise to get the flow sheet based on the recommender input
    Promise.all([getFlowSheet(recommender_input_dict)]).then((res) => {
      // Decrypt the data from the response
      const decData = decrypt_data(res[0].data);
      const handleFileResponse = (fileName) => {
        switch (fileName) {
          case 'Invalid Inputs!!!!':
            openModelPopUp('Invalid Inputs!!!!', 'Error', 'error');
            setIsShowErrorMessage(true);
            break;
          case 'No design can meet the requirements':
            setIsShowErrorMessage(true);
            break;
          default:
            if (fileName && Object.keys(fileName).length > 0) { // Check if filename is truthy in the default case
              setIsShowErrorMessage(false);
              setLoadedFile(fileName);
              const appWixObj = {
                application: recommender_input_dict.app_type,
                feedWater: recommender_input_dict.water_type,
                pTreatment: recommender_input_dict.pretreatment,
                feedFlow: FlowValue
              };
              localStorage.setItem('appWiz', JSON.stringify(appWixObj));
            } else {
              setIsShowErrorMessage(true);
            }
        }
      };
      if (decData.file_name) {
        handleFileResponse(decData.file_name);
      } else {
        setIsShowErrorMessage(true);
      }
      // Set loading state to false
      setFetchLoading(false);
    }).catch(() => {
      // If there's an error, set loading state to false and open a modal popup with an error message
      setFetchLoading(false);
      openModelPopUp('Failed to fetch Flowsheet Selection record', 'Error', 'error');
    });
  };
  const handleFlow = (value) => {
    setCheckedFlow(value); // Update the checked flow state
  };
  return (
    <Grid container className='Wizard_Container'>
      <Grid item xs={12} className='Main_Heading L_heading'><span >{translateObject('Application Wizard')}</span></Grid>
      <Grid item xs={12}>
        {fetchLoading && <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          style={{
            background: '#d9dbde5c',
          }}
          open={fetchLoading}>
          <CircularProgress style={{ color: '#4b93f4' }} size={40} disableShrink />
        </Backdrop>}
      </Grid>
      <Grid item xs={12}>
        <Grid container className='PreConfig_container'>
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid item xs={12} className='PreConfig_SideMenu'>
            <Grid container spacing={2.5}>
              <Grid item xs={12} md={3} nowrap="true">
                <span className='PreConfig_LabelGroup'>
                  <img src={Application} alt="Application" className="PreConfig_icon" />
                  <div className='PreConfig_label'>{translateObject('Application')}</div>
                </span>
                <div className='PreConfig_Box'>
                  <div className='PreConfig_App'>
                    {handleSubList('Application').map((data, j) => {
                      let icon;
                      if (selected.Application === data) {
                        icon = <DoneIcon />;
                      }
                      return (
                        <MuiChipCustom key={j}
                          icon={icon}
                          label={translateObject(data)}
                          id={data}
                          data-testid={`app-${j}`}
                          onClick={(e) => handleOnClick(e, 'Application', data)}
                          className={selected.Application === data ? 'SelectedmultiChip' : 'multiChip'}
                        />
                      );
                    })}
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <span className='PreConfig_LabelGroup'>
                  <img src={FeedWater} alt="FeedWater" className="PreConfig_icon" />
                  <div className='PreConfig_label'>{translateObject('Feed Water')}</div>
                </span>
                <div className='PreConfig_Box'>
                  {handleSubList('Feed Water').map((data, j) => {
                    let icon;
                    if (selected['Feed Water'] === data) {
                      icon = <DoneIcon />;
                    }
                    return (
                      <MuiChipCustom key={j}
                        icon={icon}
                        label={translateObject(data)}
                        id={data}
                        data-testid={`fwater-${j}`}
                        onClick={(e) => handleOnClick(e, 'Feed Water', data)}
                        className={selected['Feed Water'] === data ? 'SelectedmultiChip' : 'multiChip'}
                      />
                    );
                  })}
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <span className='PreConfig_LabelGroup'>
                  <img src={PreTreatment} alt="PreTreatment" className="PreConfig_icon" />
                  <div className='PreConfig_label'>{translateObject('Pre Treatment')}</div>
                </span>
                <div className='PreConfig_Box'>
                  {handleSubList('Pre Treatment').map((data, j) => {
                    let icon;
                    if (selected['Pre Treatment'] === data) {
                      icon = <DoneIcon />;
                    }
                    return (
                      <MuiChipCustom key={j}
                        icon={icon}
                        label={translateObject(data)}
                        id={data}
                        data-testid={`treatment-${j}`}
                        onClick={(e) => handleOnClick(e, 'Pre Treatment', data)}
                        className={selected['Pre Treatment'] === data ? 'SelectedmultiChip' : 'multiChip'}
                      />
                    );
                  })}
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <span className='PreConfig_LabelGroup'>
                  {/* <img src={FeedFlow} alt="FeedFlow" className="PreConfig_icon" /> */}
                  {/* <div className='PreConfig_label'></div> */}
                  <RadioGroup row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group" onChange={(e) => handleFlow(e.target.value)}
                  >
                    <FormControlLabel value="Feed Flow" control={<Radio checked={checkedFlow === 'Feed Flow'} />} label={translateObject('Feed Flow')} />
                    <FormControlLabel value="Product Flow" control={<Radio checked={checkedFlow === 'Product Flow'} />} label={translateObject('Product Flow')} />
                  </RadioGroup>
                </span>
                <div className='PreConfig_feedflow'>
                  <Grid container className='PreConfig_textbox'>
                    <Grid item xs={12} className='dosing-select'>
                      <Grid container spacing={1} className='flow_input_container'>
                        <Grid item xs={5}>
                          <input type='number' id='safefactvol' value={FlowValue} onFocus={e => e.target.select()} onBlur={(e) => { handleOnBlur(e); }} onChange={(e) => { handleOnChange(e); }} onInput={(e) => { setFlowValue(e.target.value); }}
                            className='cancel-handle Defautl_Large_input' placeholder={translateObject('Type here…')} />
                        </Grid>
                        <Grid item xs={5}>
                          <div className='PreConfig_Unitstext'>
                            <Grid item xs={12}><span className='no_drag PreCofig_unit'>{units.flow}</span></Grid>
                            <Grid item xs={12}><span id='appWiz_flowRange' className='no_drag'>{`(${flowRange.min} - ${flowRange.max})`}</span></Grid>
                          </div>
                        </Grid>
                        <Grid item xs={2}>
                          <Button aria-label="units" className='icon_Button'
                            onClick={() => setVisibleUnits(true)}>
                            <img src={systemUnitsIconColor} className="img-top" alt='units_color' />
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Button variant="contained" id='appwizard_seeResult' className='Primary_Default_Button ' onClick={handleResultClick} disabled={ButtonLoads}>{translateObject('See Result')}</Button>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className='PreConfig_results_item'>
            <span className='PreConfig_Design_label'>{translateObject('Result')}</span>
            <Grid container className='FlowSheet_Data'>
              {!isShowErrorMessage && (loadedFile?.s3_files || []).map((obj, i) => (
                <Grid item xs={3.85} className='RomCard' key={i}>
                  {fetchLoading && <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    style={{
                      background: '#d9dbde5c',
                    }}
                    open={fetchLoading}>
                    <CircularProgress style={{ color: '#4b93f4' }} size={40} disableShrink />
                  </Backdrop>}
                  {(loadedFile?.top_3_array_conf?.[i] ?? []).map((val, i) => (
                    <React.Fragment key={i}>
                      {i !== 0 && <hr className='ROMPass_line' />}
                      {Array.isArray(val) ? ( // Check if 'val' is an array
                        <Grid container className='ROMpass S_Regular'>
                          <Grid item xs={12}><span className='M_Bold'>{val[0]}</span></Grid>
                          <Grid item xs={12} className='ROMpass_value'>
                            <Grid item xs={6.5}>{translateObject('Array')}<span className='Value S_Bold'>{val[1]}{' '}{val[2]}</span></Grid>
                            <Grid item xs={5}>{translateObject('# of Elements')}<span className='Value S_Bold'>{val[3]}</span></Grid>
                            <Grid item xs={6.5}>{translateObject('Element Model')} <span className='Value S_Bold'>{val[4]}</span></Grid>
                            <Grid item xs={5}>{translateObject('Flux')}<span className='Value S_Bold'>{val[5]?.toFixed(2)}{' '}{units.flux}</span></Grid>
                          </Grid>
                        </Grid>
                      ) : ( // If 'val' is NOT an array
                        <Grid container className='ROMpass S_Regular'>
                          <Grid item xs={12}><span className='M_Bold'>Recommended ECell-Stack</span></Grid>
                          <Grid item xs={12} className='ROMpass_value'>
                            <Grid item xs={12}>{translateObject('Stack Model')}<span className='Value S_Bold'>{val}</span></Grid>
                          </Grid>
                        </Grid>
                      )}
                    </React.Fragment>
                  ))}
                  <Button className="Secondary-Default_button " variant="contained"
                    onClick={() => navigate(`/main?temp_files/${obj}`)}
                    endIcon={<img src={ROMOpen} alt="ROMOpen" />}>{translateObject('Open')}</Button>
                </Grid >
              ))}
              {!isShowErrorMessage && loadedFile?.Error && <div>{loadedFile?.Error}</div>}
              {isShowErrorMessage && <div>{translateObject('Please use the RO-EDI Equipment Selector. Please consult Veolia for further support.')}</div>}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {visibleUnits && (
        <ExecuteContext.Provider value={executeEDIInfoData}>
          <SystemUnits
            visibleUnits={visibleUnits}
            handleCloseUnits={handleCloseOption}
            visibleDefaultUnits
            translateObject={translateObject}
          />
        </ExecuteContext.Provider>
      )}
    </Grid>
  );
}

export default FlowSheetWizardv1;